import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Backdoor from "./pages/Backdoor";
import Dashboard from "./pages/Dashboard";
import Application from "./pages/Applications";
import Callback from "./pages/Callback";
import { Button, Container, Modal, Row } from "react-bootstrap";
import DOMPurify from "dompurify";
import { useSelector, useDispatch } from "react-redux";
import { clearMessage } from "./state/slices/message";

export const DEBUG = false;

function App() {
  const message = useSelector((state) => state.message);
  const dispatch = useDispatch();

  return (
    <div className="App">
      <Modal
        animation={false}
        show={message.text ? true : false}
        onHide={() => dispatch(clearMessage())}
      >
        <Modal.Header closeButton>
          <Modal.Title>Message!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <div
                className="text-left"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(message.text),
                }}
              />
            </Row>
            <Row>
              {message.error && (
                <details style={{ width: "100%" }}>
                  <summary>Details</summary>
                  <pre>
                    <code>{message.error}</code>
                  </pre>
                </details>
              )}
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => dispatch(clearMessage())}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Router basename={process.env.REACT_APP_BASENAME}>
        <Switch>
          <Route exact path="/" component={Homepage} />
          <Route exact path="/login" component={Backdoor} />
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/applications" component={Application} />
          <Route path="/callback" component={Callback} />
          <Route>
            {" "}
            {/* undefined routes redirect to dashboard */}
            <Dashboard />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
